export default __webpack_public_path__ + "static/ASLA_Tonyo_1-88833207fdb1289cd77f6d0231a69b84.png";